const Data = [
    {
        type: "QCM",
        title: "Quelle décision prenez-vous à la lecture du TEP intermédiaire ?",
        r: [
            "Biopsie de l’adénopathie du hile hépatique",
            "Poursuite du traitement par 2 cures de R-CHOP et TEP EOT",
            "Traitement de deuxième ligne par Glofitamab GemOx",
            "Traitement par CAR-T cells en L2",
        ],
        qcm: true,
        puces: true,
    },
    {
        type: "QCM",
        title: "Quelle décision prenez-vous à la lecture du TEP de fin de traitement ?",
        r: [
            "Contrôle à 2 mois du TEP scanner",
            "Traitement de deuxième ligne par Glofitamab GemOx",
            "Traitement par Axi-Cel en L2",
            "Traitement par Liso-Cel en L2",
        ],
        qcm: true,
        puces: true,
    },
    {
        type: "QCM",
        title: "Devant l’échappement au « Bridge », que proposez-vous ?",
        r: [
            "Maintien de la programmation de l’hospitalisation",
            "Avancement de l’hospitalisation et de la lymphodéplétion pour injection dès réception du CAR-T",
            "« Deuxième » Bridge par R Holoxan VP16",
            "Traitement en troisième ligne par bispécifique CD3xC20 Glofitamab ou Epcoritamab",
        ],
        qcm: true,
        puces: true,
    },
]

export default Data;